export enum RecordCrudResultMessageEnum {
  RecordCreatedSuccessfully = 'RecordCreatedSuccessfully',
  FailedCreatingRecord = 'ErrorCreatingRecord',
  RecordDeletedSuccessfully = 'RecordDeletedSuccessfully',
  FailedDeletingRecord = 'FailedDeletingRecord',
  RecordsListFetchedSuccessfully = 'RecordsListFetchedSuccessfully',
  RecordListEmpty = 'RecordListEmpty',
  FailedFetchingRecordList = 'FailedFetchingRecordList',
  RecordFetchedSuccessfully = 'RecordFetchedSuccessfully',
  FailedFetchingRecord = 'FailedFetchingRecord',
  RecordNotFound = 'RecordNotFound',
  RecordUpdatedSuccessfully = 'RecordUpdatedSuccessfully',
  FailedUpdatingRecord = 'FailedUpdatingRecord',
  RecordRemovedSuccessFully = 'RecordRemovedSuccessFully',
}
